var _path, _path2, _path3, _path4, _path5, _path6, _path7, _path8, _path9, _path10;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgFlytrexLogoSmall(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 156,
    height: 17,
    viewBox: "0 0 156 17",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M26.6116 0.0568848H23.9956V16.9999H40.624L41.9471 14.9212H26.6116V0.0568848Z",
    fill: "#242424"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M49.3741 7.34667L41.2253 0.0568848H37.4365L48.1412 9.5393V16.9715H50.7573V9.5393L61.4019 0.0568848H57.6432L49.3741 7.34667Z",
    fill: "#242424"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M62.845 2.13561H72.377V16.9999H74.993V2.13561H83.3223L84.6453 0.0568848H62.875V2.13561H62.845Z",
    fill: "#242424"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M106.235 4.66995C106.235 1.7939 103.619 0.0568848 99.1989 0.0568848H87.8026V2.13561H98.8381C102.958 2.13561 103.469 3.50245 103.469 4.66995C103.469 5.86593 102.958 7.23277 98.8381 7.23277H87.8026V16.9715H90.4187V9.3115H98.6877L104.01 16.9715H107.077L101.454 9.14064C104.551 8.3718 106.235 6.77716 106.235 4.66995Z",
    fill: "#242424"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M130.471 0.0568848H111.678V2.22104H129.118L130.471 0.0568848Z",
    fill: "#242424"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M127.314 7.40356H111.678V9.56772H125.961L127.314 7.40356Z",
    fill: "#242424"
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    d: "M111.678 16.9431H129.298L130.621 14.7789H111.648V16.9431H111.678Z",
    fill: "#242424"
  })), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    d: "M0 2.19235H18.7934L20.1165 0.0281982H0V2.19235Z",
    fill: "#242424"
  })), _path9 || (_path9 = /*#__PURE__*/React.createElement("path", {
    d: "M0 8.14402V9.59629V17H2.34542V9.59629H15.6361L16.9592 7.43213H0V8.14402Z",
    fill: "#242424"
  })), _path10 || (_path10 = /*#__PURE__*/React.createElement("path", {
    d: "M146.799 8.48577L146.949 8.37186L156 0.0284758H152.692L145.295 6.83417L145.175 6.94808L137.628 0H134.32L143.491 8.48577L134.29 16.9431H137.597L145.145 9.99498L145.295 10.1089L152.692 16.9146H156L146.949 8.57119L146.799 8.48577Z",
    fill: "#242424"
  })));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgFlytrexLogoSmall);
export default __webpack_public_path__ + "static/media/flytrex-logo-small.65a6872c87abcc213ad3c64160175119.svg";
export { ForwardRef as ReactComponent };